import React, { createContext, useContext, useState, useCallback } from "react";

interface OverlayContextType {
  registerOverlay: () => void;
  unregisterOverlay: () => void;
  isOverlayOpen: boolean;
}

const OverlayContext = createContext<OverlayContextType>({
  registerOverlay: () => {},
  unregisterOverlay: () => {},
  isOverlayOpen: false,
});

export function OverlayProvider({ children }: { children: React.ReactNode }) {
  const [count, setCount] = useState(0);

  const registerOverlay = useCallback(() => setCount((c) => c + 1), []);
  const unregisterOverlay = useCallback(
    () => setCount((c) => Math.max(0, c - 1)),
    [],
  );

  return (
    <OverlayContext.Provider
      value={{
        registerOverlay,
        unregisterOverlay,
        isOverlayOpen: count > 0,
      }}
    >
      {children}
    </OverlayContext.Provider>
  );
}

export function useOverlayContext() {
  return useContext(OverlayContext);
}
